module.exports = __webpack_public_path__ + "static/media/rotate_icon.67747d41.svg";